module.exports = __webpack_public_path__ + "packs/media/images/covid/covid_2-5b24c6ac98cb223072de922cf76ffe71.png";